import React from 'react';

type BadgeVariant =
  | 'verified'
  | 'active' |'pending' |'paused' |'draft' |'archived' |'rising' |'featured' |'new' |'completed' |'in-progress';

interface StatusBadgeProps {
  variant: BadgeVariant;
  label?: string;
  size?: 'sm' | 'md';
}

const variantMap: Record<BadgeVariant, { bg: string; text: string; dot: string }> = {
  verified: { bg: 'bg-primary/15', text: 'text-primary', dot: 'bg-primary' },
  active: { bg: 'bg-positive/15', text: 'text-positive', dot: 'bg-positive' },
  pending: { bg: 'bg-warning/15', text: 'text-warning', dot: 'bg-warning' },
  paused: { bg: 'bg-muted-foreground/15', text: 'text-muted-foreground', dot: 'bg-muted-foreground' },
  draft: { bg: 'bg-info/15', text: 'text-info', dot: 'bg-info' },
  archived: { bg: 'bg-muted', text: 'text-muted-foreground', dot: 'bg-muted-foreground' },
  rising: { bg: 'bg-accent/15', text: 'text-accent', dot: 'bg-accent' },
  featured: { bg: 'bg-primary/20', text: 'text-primary', dot: 'bg-primary' },
  new: { bg: 'bg-positive/15', text: 'text-positive', dot: 'bg-positive' },
  completed: { bg: 'bg-positive/15', text: 'text-positive', dot: 'bg-positive' },
  'in-progress': { bg: 'bg-info/15', text: 'text-info', dot: 'bg-info' },
};

const labelMap: Record<BadgeVariant, string> = {
  verified: 'Verified',
  active: 'Active',
  pending: 'Pending Review',
  paused: 'Paused',
  draft: 'Draft',
  archived: 'Archived',
  rising: 'Rising',
  featured: 'Featured',
  new: 'New',
  completed: 'Completed',
  'in-progress': 'In Progress',
};

export default function StatusBadge({ variant, label, size = 'md' }: StatusBadgeProps) {
  const styles = variantMap[variant];
  const displayLabel = label ?? labelMap[variant];

  return (
    <span
      className={`inline-flex items-center gap-1.5 font-500 rounded-full ${styles.bg} ${styles.text} ${
        size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-xs px-2.5 py-1'
      }`}
    >
      <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${styles.dot}`} />
      {displayLabel}
    </span>
  );
}